import Vue from 'vue';
import globalMixin from './global.js';

Vue.mixin(globalMixin);